import { API_ENDPOINTS } from '../constants/api';
import apiClient from '../config/axiosInterceptors';
import { ResponseHandler } from '../config/responseHandler';

class HelpService {
  /**
   * Submit contact form
   * @param {Object} contactData - Contact form data
   * @param {string} contactData.name - User's name
   * @param {string} contactData.email - User's email
   * @param {string} contactData.reason - Feedback reason
   * @param {string} contactData.subject - Subject of the message
   * @param {string} contactData.message - Message content
   * @param {string} contactData.file - Comma-separated file keys (optional)
   * @returns {Promise<Object>} Response data
   */
  async submitContactForm(contactData) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.CONTACT_FORM, contactData);
      return ResponseHandler.handleSuccess(response);
    } catch (error) {
      return ResponseHandler.handleError(error);
    }
  }

  /**
   * Report a content creator for impersonation
   * @param {string} creatorId - ID of the creator being reported
   * @param {Object} reportData - Report data
   * @param {string} reportData.reason - Reason for the report
   * @param {string} reportData.account_linked - Username of the account being impersonated
   * @returns {Promise<Object>} Response data
   */
  async reportContentCreator(creatorId, reportData) {
    try {
      const response = await apiClient.post(
        `${API_ENDPOINTS.REPORT_CONTENT_CREATOR}/${creatorId}`,
        reportData
      );
      return ResponseHandler.handleSuccess(response);
    } catch (error) {
      return ResponseHandler.handleError(error);
    }
  }
}

export default new HelpService();
